import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { DepressionScreeningFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: DepressionScreeningFormValues;
}

const mapEnumToLabel = (value: string) => {
  if (!value) return "-";
  if (value === "NOT_APPLICABLE") return "Not Applicable";
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="During the past month, the client has been bothered by feeling down, depressed, or hopeless."
        value={mapEnumToLabel(formValues.feelingDown)}
      />
      <LabeledText
        label="During the past month, the client has been bothered by little interest or pleasure in doing things?"
        value={mapEnumToLabel(formValues.littleInterest)}
      />
    </Grid>
  );
};

export default ViewFields;
